
const BrokeragePhilosophy = () => {
  return (
    <section className="py-16 bg-nexx-dark text-white relative overflow-hidden grid-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl lg:text-4xl font-bold mb-6">
          This Is What Brokerage Should Be
        </h2>
        <p className="text-xl text-gray-300 mb-4">
          We don't broker for the commission. We broker for the outcome.
        </p>
        <p className="text-lg text-nexx-green font-semibold">
          That's the difference between NEXX and everyone else.
        </p>
      </div>
    </section>
  );
};

export default BrokeragePhilosophy;
